var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReadyToUseRewards = function SvgReadyToUseRewards(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M43 21H26v14h15c1.1046 0 2-.8954 2-2zM63 35H2c-1.104568 0-2 .8954-2 2v2h63zM45 15c0-1.1046-.8954-2-2-2H26v8h19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd0d7",
    d: "M32 9.00001C32 11.2091 30.2091 13 28 13h-6V9.00001c0-2.20913 1.7909-3.99999 4-3.99999C27.0902 5.00002 30.8 5 32 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M36 9c0 2.2091-1.7909 4-4 4h-4V9c0-2.20914 1.7909-4 4-4s4 1.79086 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28 12.4648c1.1956-.6916 2-1.9843 2-3.46486 0-1.01444-.3776-1.94068-1-2.64581-.6224.70513-1 1.63138-1 2.64583z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M28 19H6v14c0 1.1046.89543 2 2 2h18c1.1046 0 2-.8954 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M29 19H6v2h23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M30 15c0-1.1046-.8954-2-2-2H6c-1.10457 0-2 .8954-2 2v4h26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd0d7",
    d: "M20 13h-6v22h6zM14 9.00001C14 11.2091 15.7909 13 18 13h6V5c-2.4 0-3.7909.00002-6 .00002s-4 1.79086-4 3.99999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M20 9c0 2.2091 1.7909 4 4 4h4V9c0-2.20914-1.7909-4-4-4s-4 1.79086-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22 12.4649V9.00006c0-1.01444-.3776-1.94068-1-2.64581-.6224.70513-1 1.63138-1 2.64583 0 1.48052.8044 2.77322 2 3.46482",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v48H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReadyToUseRewards);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ready-to-use-rewards.7d4c414a60b23f84e630dce35814465e.svg";